import Menu from "../Menu";
import ContextMenu from "../ContextMenu";

// import Avatar from "@mui/material/Avatar";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
// import Divider from "@mui/material/Divider";
import ServiceMenu from "../../../Song/Add_to_queue_Menu";

// import Icon from "../../UI/Icon/Icon";

import {ReactComponent as ShufflePlay} from "../../../../assets/svgs/shuffle_play.svg";
import {ReactComponent as StartRadio} from "../../../../assets/svgs/start_radio.svg";
import {ReactComponent as PlayNext} from "../../../../assets/svgs/play_next.svg";
import {ReactComponent as AddToQueue} from "../../../../assets/svgs/add_to_queue.svg";
import {ReactComponent as GoToAlbum} from "../../../../assets/svgs/go_to_album.svg";
import {ReactComponent as GoToArtist} from "../../../../assets/svgs/go_to_artist.svg";
import {getKey} from "../../../../functions/uniqueSuffix";
import {useContext, useState} from "react";
import {useHistory} from "react-router-dom";
import context from "../../../../context/context";
import AuthContext from "../../../../context/AuthContext";
import {t} from "../../../../functions/i18n";
import styles from "./moreOptionsMenu.module.scss";

const ITEM_HEIGHT = 48;


const moreOptionsMenuPaperProps = {
  style: {
    // maxHeight: ITEM_HEIGHT * 3,
    height: "max-content",

    width: "20ch",
  },
};

function MoreOptionaMenu({
  menuOptions,
  serviceSuccessMsg,
  fullSpace = false,
  className,
  isContextMenu,

  children,
  ...props
}) {
  const {language} = useContext(AuthContext);

  const iconsForMenus = [
    {
      text: ["shuffle play", "play", "MUSIC_SHUFFLE", "reprodução aleatória", "tocar aleatoriamente", "aleatória"],
      standard: t(language, "shufflePlay"),
      icon: <ShufflePlay />,
    },
    {
      text: ["start radio", "radio", "iniciar rádio", "rádio"],
      standard: t(language, "startRadio"),

      icon: <StartRadio />,
    },
    {
      text: ["play next", "QUEUE_PLAY_NEXT", "next", "tocar a seguir", "tocar próxima", "próxima"],
      standard: t(language, "playNext"),
      isService: true,
      insertion: "NEXT",
      icon: <PlayNext />,
    },
    {
      text: ["add to queue", "to queue", "ADD_TO_REMOTE_QUEUE", "adicionar à fila", "fila"],
      standard: t(language, "addToQueue"),
      isService: true,
      insertion: "END",

      icon: <AddToQueue />,
    },
    {
      text: ["go to album", "to album", "album", "ir para o álbum", "álbum"],
      standard: t(language, "goToAlbum"),

      icon: <GoToAlbum />,
    },
    {
      text: ["go to artist", "to artist", "artist", "ir para o artista", "artista"],
      standard: t(language, "goToArtist"),

      icon: <GoToArtist />,
    },
  ];

  const content = (
    <IconButton {...props} className={`more-options ${className}`}>
      <MoreVertIcon style={{color: "#fff"}} />
    </IconButton>
  );

  const [isClosed, setIsClosed] = useState(false);

  const {
    setCurrentSongIndex,
    setCurrentSongParam,
    closePlayer,
    upNextSongs,
    setUpNextSongs,
    currentSong,
    // isPlayerOpen,
    // isPlayerPageOpen,
  } = useContext(context);

  const history = useHistory();

  const menuItems = menuOptions.map((option, i) => {
    const menu = iconsForMenus.find(m => {
      return (
        m.text.find(mt =>
          mt.toLowerCase().includes(option?.text.toLowerCase())
        ) || false
      );
    });

    if (!menu) return null;

    if (
      menu?.isService &&
      !option?.service?.isVideo &&
      !option?.service?.isPlaylist
    ) {
      return null;
    }

    if (menu?.isService) {
      return (
        <ServiceMenu
          style={{height: ITEM_HEIGHT}}
          key={getKey(menu.standard)}
          add_next={menu.insertion.toLowerCase().includes("next")}
          service={option.service}
          msg={serviceSuccessMsg}
          onClick={() => setIsClosed(true)}>
          <ListItemIcon style={{fill: "#ffffff"}}>{menu.icon}</ListItemIcon>
          <ListItemText className="menuList-typo">{menu.standard}</ListItemText>
        </ServiceMenu>
      );
    }

    const isSong = option?.navigate?.playlistId || option?.navigate?.videoId;
    const isBrowseable = option?.navigate?.browseId;

    const navigationParams = option?.navigate?.params;

    let endpoint;
    const playlistId = option?.navigate?.playlistId;
    const videoId = option?.navigate?.videoId;
    if (isSong) {
      endpoint = `/play${videoId ? `?id=${videoId}` : ""}${
        playlistId
          ? `${playlistId && !videoId ? "?" : "&"}list=${playlistId}`
          : ""
      }`;
    }

    if (isBrowseable) {
      const browseId = option?.navigate?.browseId;
      endpoint = `/browse/${browseId}${
        navigationParams ? `?params=${navigationParams}` : ""
      }`;
    }

    if (!endpoint) return null;

    return (
      <MenuItem
        key={getKey(menu.standard)}
        style={{height: ITEM_HEIGHT}}
        onClick={() => {
          if (endpoint?.startsWith("/play")) {
            if (currentSong?.playlistId !== playlistId) {
              setUpNextSongs([]);
            }
            setCurrentSongParam("");
            closePlayer();
          }

          history.push(endpoint);

          if (endpoint?.startsWith("/play")) {
            setCurrentSongIndex(0);
          }
        }}>
        <ListItemIcon style={{fill: "#ffffff"}}>{menu.icon}</ListItemIcon>
        <ListItemText className="menuList-typo">{menu.standard}</ListItemText>
      </MenuItem>
    );
  });

  if (isContextMenu) {
    return (
      <ContextMenu
        isClosed={isClosed}
        triggerContent={children}
        menuItems={menuItems}
      />
    );
  }

  return (
    <Menu
      isClosed={isClosed}
      onOpen={() => setIsClosed(false)}
      fullSpace={fullSpace}
      ariaLabel="more"
      contentContainerClassName="full-hw flex-center"
      id="lock-menu"
      PaperProps={{
        style: {
          height: "max-content",
          width: "28rem",
          background: "rgba(15, 15, 15, 0.75)",
          backdropFilter: "blur(40px) saturate(200%)",
          WebkitBackdropFilter: "blur(40px) saturate(200%)",
          borderRadius: "20px",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          boxShadow: "0 24px 80px rgba(0, 0, 0, 0.8), 0 8px 32px rgba(0, 0, 0, 0.5)",
          padding: "0.8rem",
          overflow: "visible",
        },
      }}
      MenuListProps={{
        "aria-labelledby": "lock-button",
        "role": "listbox",
      }}
      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
      transformOrigin={{vertical: "top", horizontal: "right"}}
      triggerContent={content}
      menuItems={menuItems}
    />
  );
}

// function areEqual(prevProps, nextProps) {
//   const prevOptionTexts = prevProps?.menuOptions?.reduce(
//     (p, c) => p + c?.text,
//     ""
//   );
//   const nextOptionTexts = nextProps?.menuOptions?.reduce(
//     (p, c) => p + c?.text,
//     ""
//   );

//   console.log("render MoreOptionaMenu", prevOptionTexts, nextOptionTexts);

//   return prevOptionTexts === nextOptionTexts;
// }

export default /*memo*/ MoreOptionaMenu;

